module.exports = __webpack_public_path__ + "icon_2.2764245d.png";